export function sortFilesWithMainImageFirst<T extends { _id?: string }>(
	files: T[],
	mainImageId?: string | null
): T[] {
	if (!mainImageId) return files;
	const mainIdx = files.findIndex(f => f._id === mainImageId);
	if (mainIdx === -1) return files;
	return [files[mainIdx], ...files.slice(0, mainIdx), ...files.slice(mainIdx + 1)];
}
